import { Component, HostListener, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { CommonModule } from '@angular/common';
import { isPlatformBrowser } from '@angular/common';
import { MangaInfoComponent } from '../manga-info/manga-info.component'; 
import { MangaEpisodeComponent } from '../manga-episode/manga-episode.component';
import { Author, Manga, Episode } from '../interfaces/manga.interfaces';

@Component({
  selector: 'app-manga-preview',
  imports: [CommonModule, MangaInfoComponent, MangaEpisodeComponent],
  templateUrl: './manga-preview.component.html',
  styleUrl: './manga-preview.component.css'
})

export class MangaPreviewComponent implements OnInit {
  //@Input author!: Author;
  //@Input() manga!: Manga;
  //@Input() episodes!: Episode[];
  isMobileView: boolean = false;

  author =  {
    name: "Christopher Nolan",
    photo: "https://m.media-amazon.com/images/M/MV5BMjI0MTg3MzI0M15BMl5BanBnXkFtZTcwMzQyODU2Mw@@._V1_FMjpg_UX297_.jpg",
    social: [
      { platform: "Twitter", link: "https://twitter.com/nolan" },
      { platform: "IMDb", link: "https://www.imdb.com/name/nm0634240/" },
      { platform: "Facebook", link: "https://www.imdb.com/name/nm0634240/" }
    ]
  };


  manga = {
    cover: "https://m.media-amazon.com/images/I/71ew6t3ZIzL._SL1500_.jpg",
    title: "Evangelion Collector's Edition N.1",
    langs: ["EN", "JP"],
    tags: ["Action", "Fantasy"],
    description: "A BOY WANTS TO STOP A WAR, AND EVERY UNEXPECTED THING HAPPENS CONSECUTIVELY, MAKING HIM AWAKEN TO THE TRUTH THAT HE IS THE ONE WHO HAS THE KEY TO STOP IT ALL.",
    published: "2021-07-01",
    updated: "2024-07-01",
    stats: {
      views: 4500000,
      stars: 123,
      comments: 123
    }
  };

  episodes: Episode[] = [
    { 
      title: "Episode 1", 
      description: "Introduction to the dream world.", 
      image: "https://m.media-amazon.com/images/M/MV5BMjAxMzY3NjcxNF5BMl5BanBnXkFtZTcwNTI5OTM0Mw@@._V1_FMjpg_UX700_.jpg"
    },
    { 
      title: "Episode 2", 
      description: "Exploring subconscious manipulation.", 
      image: "https://m.media-amazon.com/images/M/MV5BMjAxMzY3NjcxNF5BMl5BanBnXkFtZTcwNTI5OTM0Mw@@._V1_FMjpg_UX700_.jpg"
    },
    { 
      title: "Episode 3", 
      description: "The final heist begins.", 
      image: "https://m.media-amazon.com/images/M/MV5BMjAxMzY3NjcxNF5BMl5BanBnXkFtZTcwNTI5OTM0Mw@@._V1_FMjpg_UX700_.jpg"
    },
    { 
      title: "Episode 4", 
      description: "The final heist begins.", 
      image: "https://m.media-amazon.com/images/M/MV5BMjAxMzY3NjcxNF5BMl5BanBnXkFtZTcwNTI5OTM0Mw@@._V1_FMjpg_UX700_.jpg"
    },
    { 
      title: "Episode 2", 
      description: "Exploring subconscious manipulation.", 
      image: "https://m.media-amazon.com/images/M/MV5BMjAxMzY3NjcxNF5BMl5BanBnXkFtZTcwNTI5OTM0Mw@@._V1_FMjpg_UX700_.jpg"
    },
    { 
      title: "Episode 3", 
      description: "The final heist begins.", 
      image: "https://m.media-amazon.com/images/M/MV5BMjAxMzY3NjcxNF5BMl5BanBnXkFtZTcwNTI5OTM0Mw@@._V1_FMjpg_UX700_.jpg"
    }
  ];

  constructor(@Inject(PLATFORM_ID) private platformId: object) {}

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.isMobileView = window.innerWidth < 1200;
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    if (isPlatformBrowser(this.platformId)) {
      this.isMobileView = window.innerWidth < 1200;
    }
  }
}